














import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class LinkBlock extends Vue {
  @Prop({ required: true }) public id: string;
  @Prop({ required: false, default: 13 }) public length: number;

  get hasDefaultSlot(): boolean {
    return !!this.$slots.default;
  }
}
